<template>
  <div class="col-md-12">
    <!-- <b-alert variant="danger" show dismissible>
      For data sanity, we have changed the process of changing the status.
      Please abide by the guidelines.
    </b-alert> -->
    <div class="col-md-12 m-0 p-0">
      <h3>You are about to change the status to {{ metaData.funnel }}!</h3>
    </div>
    <div class="row">
      <div class="col-md-7 py-4">
        <div>
          <div class="col-md-6 m-0 p-0">
            <b-alert variant="success" :show="!selectedOption">
              <b-icon icon="chat"></b-icon>
              Please select comment to begin.
            </b-alert>
            <b-button variant="light border" v-b-modal.modal-1
              >Select Comment</b-button
            >

            <b-modal
              class="m-0 p-0"
              ref="select-comment"
              id="modal-1"
              hide-footer
              scrollable
              centered
              title="Select Comment"
            >
              <div class="options-container">
                <div
                  @click="selectOption(data)"
                  class="py-2 px-2 option-items"
                  v-for="(data, index) in options"
                  :key="index"
                >
                  <p class="m-0 p-0">{{ data.name }}</p>
                  <span class="label">{{ data.label }}</span>
                </div>
              </div>
            </b-modal>
          </div>
          <div v-if="selectedOption">
            <div class="card col-md-8 my-3 pt-2">
              <span class="label">Selected Comment</span>
              <p class="m-0 p-0">
                {{ selectedOption.name }} - {{ selectedOption.label }}
              </p>
              <b-button
                class="my-3"
                size="sm"
                variant="light border"
                v-b-modal.modal-1
                >Change</b-button
              >
            </div>
            <div
              class="col-md-8 my-2 p-0"
              v-if="
                selectedOption.name === 'Others' ||
                  selectedOption.name === 'OFA'
              "
            >
              <b-form-group
                id="input-group-1"
                label="Describe:"
                label-for="input-1"
                description="We recommend you to chose from pre-defined comments."
              >
                <b-textarea
                  id="input-1"
                  v-model="comment"
                  type="tect"
                  placeholder="Please enter full description (mandatory)"
                  required
                ></b-textarea>
              </b-form-group>
            </div>
            <div
              class="col-md-8 my-2 p-0"
              v-if="
                selectedOption.name === 'Will pay later' ||
                selectedOption.name === 'Follow Up' ||
                selectedOption.name === 'Customer will drop'
              "
            >
              <b-form-group
                id="input-group-1"
                label="Enter Date:"
                label-for="input-1"
                description="This is required for notifications."
              >
                <b-datepicker
                  id="input-1"
                  v-model="date"
                  type="tect"
                  placeholder="Enter date"
                  required
                ></b-datepicker>
              </b-form-group>
            </div>
            <div class="my-4">
              <div v-if="loading">
                <b-spinner></b-spinner>
                <span class="pl-2">Please Wait</span>
              </div>
              <b-button
                @click="changeFlag"
                :disabled="noValid || loading"
                class="my-3 confirm"
                variant="danger border"
                >I'm sure, change the status</b-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5 border my-4 p-2">
        <h5>Recent Comments</h5>
        <div
          class="comments-container"
          style="min-height:300px;max-height:350px;overflow:scroll"
        >
          <div
            class="col-md-10 border p-2 my-2"
            v-for="(data, index) in agentCommentData"
            :key="index"
          >
            <p class="m-0 p-0" v-if="index == 0">
              <b-badge variant="danger">Latest</b-badge>
            </p>
            <span class="label-xs m-0 p-0">{{
              checkFunnel(data.current_flag)
            }}</span>
            <p class="m-0 p-0 mb-2">{{ data.comment }}</p>
            <span class="label mt-3"
              ><em
                >{{ data.userName }}, {{ data.createdAt | moment("lll") }}</em
              ></span
            >
          </div>
          <div class="my-5 col-md-12 text-center" v-if="loading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
            <p>We are loading</p>
          </div>
          <div
            class="my-5 col-md-12 text-center"
            v-if="!loading && agentCommentData.length === 0"
          >
            <b-icon
              icon="chat-left-dots"
              style="width: 30px; height: 30px;"
            ></b-icon>
            <p>No comments yet</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flagsJson from "../../Inventory/flags";
import commentsData from "../../Inventory/comments"
import * as _ from "lodash";
import {eventBus} from '../../main'
export default {
  data() {
    return {
      flagsJson: flagsJson,
      comment: "",
      date: "",
      selectedOption: null,
      options: commentsData,
      funnel: ''
    };
  },
  props: {
    id: Number,
    metaData: Object,
  },
  created() {
    console.log(this.id);
    this.getAgentCommentsData();
    if(this.metaData.funnelUrl){
      this.funnelUrl = this.metaData.funnelUrl
    }else{
      this.funnelUrl = 'booking'
    }
    console.log(this.funnelUrl)

    // this.$refs['changeStatusModal'].show()
  },
  methods: {
    getAgentCommentsData() {
      this.$store.dispatch("get_agent_comment_data", { id: this.id });
    },
    selectOption(data) {
      this.selectedOption = data;
      this.comment = data.name;
      this.$refs["select-comment"].hide();
    },
    checkFunnel(id) {
      var x = this.flagsJson.filter((x) => {
        return x.flag == id;
      });
      return x[0].funnel + " -" + x[0].state.toLowerCase();
    },
    changeFlag() {
      var obj = {
        comment: this.comment,
        flag: this.metaData.flag,
        activeChange: this.selectedOption.activeStatus,
        bookingId: this.metaData.bookingId,
        dispatch: this.metaData.dispatch,
        funnelUrl: this.funnelUrl,
        dispatchPayload: this.metaData.dispatchPayload ? this.metaData.dispatchPayload : null,
      };
      this.$store
        .dispatch("change_booking_flag", obj)
        .then(() => {
          this.getAgentCommentsData();
          eventBus.$emit(this.metaData.event, true);
          this.$toasted.show("Status Changed Sucessfully.", { type: "success" }).goAway(2000);
        })
        .catch((err) => {
          this.$bvToast.toast(`${err}`, {
            title: "Something went wrong.",
            autoHideDelay: 5000,
          });
        });
    },
  },
  computed: {
    loading() {
      return this.$store.state.loading_api;
    },
    agentCommentData() {
      return _.orderBy(
        this.$store.state.agent_comment_data,
        "createdAt",
        "desc"
      );
    },
    noValid() {
      if (!this.comment) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scope>
.option-items {
  cursor: pointer;
  font-weight: bold;
}
.option-items:hover {
  background: #e2e2e2;
  color: #5652c2;
}
.label {
  font-size: 14px;
  color: gray;
  font-weight: 400 !important;
}
.label-xs {
  font-size: 12px;
  color: gray;
  font-weight: 400 !important;
}
.confirm:disabled {
  cursor: not-allowed;
}
</style>
